"use client";

import { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { switchTeacher } from "@/actions/users/user";
import { Classification } from "@/types/classification";
import { useAuth } from "@/providers/AuthProvider";
import { getUserQueryKey } from "@/types/users/user";
import { Loading } from "@/components/Loading";
import { ClassificationBar } from "@/app/activities/search/ClassificationBar";
import { Button } from "@/components/buttons/Button";
import { Title } from "@/components/Title";

interface SwitchSchoolProps {
    onSwitch: () => void;
}

export default function SwitchSchool({ onSwitch }: SwitchSchoolProps) {
    const { user, userLoading } = useAuth();

    const [selectedTeacherId, setSelectedTeacherId] = useState<
        number | undefined
    >(undefined);

    const queryClient = useQueryClient();

    const { mutateAsync: switchTeacherMutation } = useMutation({
        mutationFn: async () => {
            if (
                selectedTeacherId &&
                selectedTeacherId !== user?.current_teacher?.id
            ) {
                await switchTeacher(selectedTeacherId!);
                await queryClient.refetchQueries({
                    queryKey: getUserQueryKey(),
                });
            }
            onSwitch();
        },
    });

    useEffect(() => {
        setSelectedTeacherId(user?.current_teacher?.id ?? undefined);
    }, [user]);

    return (
        <>
            <Title title='באיזה בי"ס את.ה היום?' />

            {userLoading ? (
                <Loading />
            ) : (
                <>
                    <ClassificationBar
                        classifications={
                            (user?.teachers
                                ?.filter(
                                    (teacher) =>
                                        teacher.currently_active &&
                                        teacher.school?.name
                                )
                                .map((teacher) => {
                                    return {
                                        id: teacher.id,
                                        name: teacher.school?.name,
                                        icon: teacher.school?.logo,
                                    };
                                }) as Classification[]) || []
                        }
                        selectedClassificationId={selectedTeacherId}
                        onClick={(teacher) => setSelectedTeacherId(teacher.id)}
                        variant={"buttons-single-column"}
                    />
                    <Button
                        onClick={switchTeacherMutation}
                        variant="primary"
                        icon="left"
                        disabled={!selectedTeacherId}
                    >
                        המשך
                    </Button>
                </>
            )}
        </>
    );
}
